module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-landing-page-layout', [_c('div', {
    staticClass: "flex h-screen overflow-y-auto"
  }, [_c('div', {
    staticClass: "mx-auto mt-12"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "w-24",
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_captcha),
      expression: "show_captcha"
    }],
    staticClass: "recaptcha-container mt-4"
  }, [_c('div', {
    attrs: {
      "id": "g-recaptcha",
      "data-sitekey": _vm.recaptchaKey
    }
  }), _vm._v(" "), (_vm.show_after_captcha_error) ? _c('div', [_c('button', {
    staticClass: "mt-4 px-4 py-2 bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'login'
        })
      }
    }
  }, [_vm._v("\n            Back to login\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_captcha),
      expression: "!show_captcha"
    }],
    staticClass: "sign-up-box my-5 box-border shadow-sm p-8 border-1 rounded bg-white"
  }, [_c('div', {
    staticClass: "font-medium"
  }, [_c('p', {
    staticClass: "mb-4 flex justify-center font-bold text-lg"
  }, [_vm._v("\n            Create an Account\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between mb-3"
  }, [_c('button', {
    staticClass: "flex justify-center items-center w-full p-2 border border-gray-200 border-solid rounded mr-2 disabled:opacity-50",
    class: {
      'bg-pink-100 border-pinky': _vm.user.role === 'teacher'
    },
    on: {
      "click": function($event) {
        _vm.user.role = 'teacher'
      }
    }
  }, [(_vm.user.role === 'teacher') ? _c('img', {
    staticClass: "h-8 w-8",
    attrs: {
      "src": "/static/teacher_icons/teacher_sign_up_pink.svg"
    }
  }) : _c('img', {
    staticClass: "h-8 w-8",
    attrs: {
      "src": "/static/teacher_icons/teacher_sign_up_black.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    class: {
      'text-pinky font-semibold': _vm.user.role === 'teacher',
    }
  }, [_vm._v("\n                Teacher\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "flex justify-center items-center w-full p-4 border border-gray-200 border-solid rounded ml-2 disabled:opacity-50",
    class: {
      'bg-pink-100 border-pinky': _vm.user.role === 'student'
    },
    attrs: {
      "disabled": _vm.school_invite_code
    },
    on: {
      "click": function($event) {
        _vm.user.role = 'student'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-graduation-cap text-2xl",
    class: _vm.user.role === 'student' ? 'text-pinky' : 'text-gray-700'
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2",
    class: {
      'text-pinky font-semibold': _vm.user.role === 'student',
    }
  }, [_vm._v("\n                Student\n              ")])])]), _vm._v(" "), (_vm.finalize_sso_registration && _vm.user.role !== '') ? _c('div', [(_vm.user.role === 'teacher') ? _c('div', {
    staticClass: "my-6"
  }, [_vm._v("\n              Before you can complete your registration, you must accept the\n              Parlay terms and conditions\n            ")]) : _c('div', {
    staticClass: "my-6"
  }, [_vm._v("\n              To complete your registration, you must insert the code your\n              teacher gave you\n            ")]), _vm._v(" "), (_vm.user.role === 'teacher') ? _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.has_agreed_to_terms),
      expression: "has_agreed_to_terms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.has_agreed_to_terms) ? _vm._i(_vm.has_agreed_to_terms, null) > -1 : (_vm.has_agreed_to_terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.has_agreed_to_terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.has_agreed_to_terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.has_agreed_to_terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.has_agreed_to_terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-xs"
  }, [_vm._v("\n                I agree with\n                "), _c('a', {
    staticClass: "text-pinky",
    attrs: {
      "href": "https://parlayideas.com/policies/",
      "target": "_blank"
    }
  }, [_vm._v("\n                  terms and conditions.")])])]) : _c('div', [_c('label', {
    staticClass: "font-semibold mt-1"
  }, [_vm._v("Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.invite_code),
      expression: "user.invite_code"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded",
    attrs: {
      "required": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.invite_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "invite_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "mt-4 mb-6 px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": (_vm.user.role === 'teacher' && !_vm.has_agreed_to_terms) ||
        (_vm.user.role === 'student' && !_vm.user.invite_code)
    },
    on: {
      "click": _vm.completeUserRegistration
    }
  }, [_vm._v("\n              Submit\n            ")])]) : (_vm.user.role !== '') ? _c('div', [_c('div', [_c('google-button', {
    attrs: {
      "signUp": true,
      "userRole": _vm.user.role
    }
  }), _vm._v(" "), _c('microsoft-button', {
    attrs: {
      "signUp": true,
      "userRole": _vm.user.role
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center my-3 text-gray-400"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', [_vm._v("OR")])])]), _vm._v(" "), (_vm.user.role === 'student') ? _c('div', [_c('label', {
    staticClass: "font-semibold mt-1"
  }, [_vm._v("Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.invite_code),
      expression: "user.invite_code"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded",
    attrs: {
      "required": "",
      "type": "text",
      "disabled": _vm.user.role === ''
    },
    domProps: {
      "value": (_vm.user.invite_code)
    },
    on: {
      "keyup": function($event) {
        _vm.invite_code_error_message = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "invite_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs font-medium text-coolGray-500 mt-1"
  }, [_vm._v("\n                Your teacher will give you a code to join the RoundTable\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500"
  }, [_vm._v("\n                " + _vm._s(_vm.invite_code_error_message) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "mr-1"
  }, [_c('label', {
    staticClass: "font-semibold"
  }, [_vm._v("First Name "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_name),
      expression: "first_name"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none",
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "required": "",
      "type": "text",
      "disabled": _vm.user.role === ''
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "keyup": function($event) {
        _vm.first_name_error_message = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500"
  }, [_vm._v("\n                  " + _vm._s(_vm.first_name_error_message) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-1"
  }, [_c('label', {
    staticClass: "font-semibold"
  }, [_vm._v("Last Name "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last_name),
      expression: "last_name"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none",
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "required": "",
      "type": "text",
      "disabled": _vm.user.role === ''
    },
    domProps: {
      "value": (_vm.last_name)
    },
    on: {
      "keyup": function($event) {
        _vm.last_name_error_message = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500"
  }, [_vm._v("\n                  " + _vm._s(_vm.last_name_error_message) + "\n                ")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "font-semibold"
  }, [_vm._v("Email "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none",
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "required": "",
      "type": "email",
      "disabled": _vm.user.role === ''
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keyup": function($event) {
        _vm.email_error_message = null
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500"
  }, [_vm._v("\n                " + _vm._s(_vm.email_error_message) + "\n              ")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "font-semibold mt-3"
  }, [_vm._v("Password "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('password', {
    attrs: {
      "badge": false,
      "toggle": true,
      "disabled": _vm.user.role === ''
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.password_error_message = null
      }
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "password-text text-gray-400 leading-3"
  }, [_vm._v("\n                Use 8 ore more characters with a mix of letters, numbers &\n                symbols.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500"
  }, [_vm._v("\n                " + _vm._s(_vm.password_error_message) + "\n              ")])], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "font-semibold"
  }, [_vm._v("Confirm Password "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.retype_password),
      expression: "user.retype_password"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none",
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "required": "",
      "type": "password",
      "disabled": _vm.user.role === ''
    },
    domProps: {
      "value": (_vm.user.retype_password)
    },
    on: {
      "keyup": [function($event) {
        $event.preventDefault();
        _vm.retype_password_error_message = null
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.verifyUserInformation(_vm.user)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "retype_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-1 h-5 text-xs text-red-500"
  }, [_vm._v("\n                " + _vm._s(_vm.retype_password_error_message) + "\n              ")])]), _vm._v(" "), (_vm.user.role === 'teacher') ? _c('div', {
    staticClass: "flex mb-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.has_agreed_to_terms),
      expression: "has_agreed_to_terms"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.user.role === ''
    },
    domProps: {
      "checked": Array.isArray(_vm.has_agreed_to_terms) ? _vm._i(_vm.has_agreed_to_terms, null) > -1 : (_vm.has_agreed_to_terms)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.has_agreed_to_terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.has_agreed_to_terms = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.has_agreed_to_terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.has_agreed_to_terms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-xs"
  }, [_vm._v("\n                I agree with\n                "), _c('a', {
    staticClass: "text-pinky",
    attrs: {
      "href": "https://parlayideas.com/policies/",
      "target": "_blank"
    }
  }, [_vm._v("\n                  terms and conditions")]), _vm._v("\n                and I am over 13 years old.\n              ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "mb-6 px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.has_agreed_to_terms && _vm.user.role === 'teacher'
    },
    on: {
      "click": function($event) {
        return _vm.verifyUserInformation(_vm.user)
      }
    }
  }, [_vm._v("\n              Submit\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center text-xs"
  }, [_c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v(" Already have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "ml-2 text-pinky",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n              Sign In\n            ")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0faafc82!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/authentication/signup/signup_new.vue
// module id = 2344
// module chunks = 61